import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ImportExcelDto } from 'app/core/dtos/excel/import-excel';
import { ResponseApi } from 'app/core/dtos/response-api';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.apiUrl}/excel`;

  private readonly semAlertaDeSucesso = new HttpHeaders({ 'skip-success': 'true' });

  ler(arquivo: File): Observable<ResponseApi<ImportExcelDto>> {
    const formData = new FormData();
    formData.append('file', arquivo, arquivo.name);

    return this.http.post<ResponseApi<ImportExcelDto>>(`${this.baseUrl}/ler`, formData, {
      headers: this.semAlertaDeSucesso
    });
  }
}
